<template>
    <div class="vue-vehicle-group-slider">
        <hooper ref="hooper" :settings="hooperSettings" @afterSlide="handleSlide">
            <slide v-for="(slide, index) in slides" :index="index" :key="index">
                <div class="slide-inner">
                    <img :src="slide.image.url" :alt="slide.image.alt">
                    <aut-balloon class="d-none d-lg-flex">{{ slide.balloon }}</aut-balloon>
                </div>
            </slide>
        </hooper>

        <div class="hooper-navigation container">
            <div class="row g-1 w-100">
                <div class="col col-lg-10 mx-auto">
                    <button @click="slidePrev" class="prev-button">Slide previous</button>
                    <button @click="slideNext" class="next-button">Slide next</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Hooper, Slide} from 'hooper';
import 'hooper/dist/hooper.css';

export default {
    name: "VehicleGroupSlider",

    props: {
        slides: {
            type: Array,
            required: true,
        },
        newSlideId: {
            type: String | Number | undefined,
            default: undefined
        }
    },

    components: {
        Hooper,
        Slide,
    },

    data() {
        return {
            hooperSettings: {
                centerMode: true,
                wheelControl: false,
                infiniteScroll: true,
                mouseDrag: false,
                touchDrag: false,
                keysControl: false,
                itemsToShow: 1.5,
                breakpoints: {
                    768: {
                        itemsToShow: 2.5,
                    },
                }
            }
        }
    },

    created() {
        this.checkNewSlide(this.newSlideId)
    },

    methods: {
        handleSlide(payload) {
            let index = payload.currentSlide;

            if (index === -1) {
                index = 4
            }

            this.$emit('active-slide', {
                id: this.slides[index]?.id,
                group: this.slides[index]?.group,
            })
        },

        slidePrev() {
            this.$refs.hooper.slidePrev()
        },

        slideNext() {
            this.$refs.hooper.slideNext()
        },

        checkNewSlide(slideId) {
            let foundSlideIndex = this.slides.findIndex((element) => element.id === slideId)

            if (foundSlideIndex === -1 || !this.$refs.hooper) {
                return;
            }

            this.$refs.hooper.slideTo(foundSlideIndex);
        }
    },

    watch: {
        newSlideId(newVal, oldVal) {
            this.checkNewSlide(newVal);
        }
    }
}
</script>
<style scoped lang="scss">
.hooper-slide {
    img {
        pointer-events: none;
    }
}
</style>